"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDriverWillingToRentSuitableVehicle = exports.isVehicleTypeCompatible = void 0;
exports.filterSuitableVehicleInfo = filterSuitableVehicleInfo;
exports.filterSuitableVehicleModel = filterSuitableVehicleModel;
exports.filterSuitableVehicleData = filterSuitableVehicleData;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformPassengersCountToVehicleType_1 = require("../transformers/transformPassengersCountToVehicleType");
const utils_1 = require("@daytrip/utils");
function filterSuitableVehicleInfo(vehicleTypeToSuit, requiredCapacity, approvedForCountryIds) {
    const filterFunction = filterSuitableVehicleData(vehicleTypeToSuit, requiredCapacity, approvedForCountryIds);
    return (vehicleInfo) => filterFunction(vehicleInfo) && vehicleInfo.status === legacy_enums_1.VehicleStatus.Accepted;
}
function filterSuitableVehicleModel(vehicleTypeToSuit, requiredCapacity, approvedForCountryIds) {
    const filterFunction = filterSuitableVehicleData(vehicleTypeToSuit, requiredCapacity, approvedForCountryIds);
    return (vehicleModel) => filterFunction(vehicleModel) && (0, utils_1.isUndefinedOrNull)(vehicleModel.disabledAt);
}
function filterSuitableVehicleData(vehicleTypeToSuit, requiredCapacity, approvedForCountryIds) {
    const isLuxury = vehicleTypeToSuit === legacy_enums_1.VehicleType.LuxurySedan;
    return (vehicleData) => {
        for (const countryId of approvedForCountryIds) {
            if (vehicleData.approvedForCountryIds.indexOf(countryId) === -1) {
                return false;
            }
        }
        if (vehicleData.seatsCount < requiredCapacity) {
            return false;
        }
        if (isLuxury) {
            if (vehicleData.luxuryForCountryIds && vehicleData.luxuryForCountryIds.length > 0) {
                for (const countryId of approvedForCountryIds) {
                    if (vehicleData.luxuryForCountryIds.indexOf(countryId) === -1) {
                        return false;
                    }
                }
            }
            return isLuxury === vehicleData.isLuxury;
        }
        const typeOfVehicleTestedForSuitability = (0, transformPassengersCountToVehicleType_1.transformPassengersCountToVehicleType)(vehicleData.seatsCount, false, false);
        return legacy_enums_1.VehicleTypesCapacity[typeOfVehicleTestedForSuitability] >= legacy_enums_1.VehicleTypesCapacity[vehicleTypeToSuit];
    };
}
const isVehicleTypeCompatible = (vehicleType, orderVehicleType) => {
    if (orderVehicleType === legacy_enums_1.VehicleType.LuxurySedan) {
        return vehicleType === legacy_enums_1.VehicleType.LuxurySedan;
    }
    // We assume that the driver is able to rent Luxury Sedan with 3 seats in case of such Sedan/SedanLite order.
    if (vehicleType === legacy_enums_1.VehicleType.LuxurySedan) {
        return [legacy_enums_1.VehicleType.Sedan, legacy_enums_1.VehicleType.SedanLite].includes(orderVehicleType);
    }
    return legacy_enums_1.VehicleTypesCapacity[vehicleType] >= legacy_enums_1.VehicleTypesCapacity[orderVehicleType];
};
exports.isVehicleTypeCompatible = isVehicleTypeCompatible;
const isDriverWillingToRentSuitableVehicle = (rentedVehicleTypes, orderVehicleType) => {
    return rentedVehicleTypes.some((rentedVehicleType) => {
        return (0, exports.isVehicleTypeCompatible)(rentedVehicleType, orderVehicleType);
    });
};
exports.isDriverWillingToRentSuitableVehicle = isDriverWillingToRentSuitableVehicle;
//# sourceMappingURL=filterSuitableVehicle.js.map